var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBankOzoncard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#005BFF",
    d: "M35.8 40H4.2C1.9 40 0 38.1 0 35.8V4.2C0 1.9 1.9 0 4.2 0h31.5C38.1 0 40 1.9 40 4.2v31.5c0 2.4-1.9 4.3-4.2 4.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F81055",
    d: "M35.8 0h-9.4c.2.1.3.3.5.4l3.8 2.4H13c-1.6 0-3 1-3.4 2.6-.4 1.6.2 3.1 1.6 4l11.6 7.1H4.7c-1.6 0-3 1.1-3.4 2.6-.4 1.5.2 3.1 1.6 3.9l11.5 7H0v5.7C0 38.1 1.9 40 4.2 40h9.6c-.1-.1-.3-.2-.4-.3l-4.1-2.6H27a3.54 3.54 0 0 0 1.8-6.6l-11.7-7.1 18.1-.1c1.6 0 3-1.1 3.4-2.6.4-1.5-.2-3.1-1.6-3.9l-11.5-7H40V4.2C40 1.9 38.1 0 35.8 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBankOzoncard);
export default ForwardRef;